import Storage from "../storage-service/Storage";
// import ErroHandler from '../../utils/ErrorHandler'
import Data from "../../data/Data";
const managerBff = process.env.REACT_APP_MANAGER_BFF_URL;
import { EditMiniApp } from "../models/EditMiniApp";
import { Credential } from "../models/Credential";
import { CreateMiniApp } from "../models/CreateMiniApp";
import ErrorHandler from "../../utils/ErrorHandler";
import { Customer } from "../models/Customer";
import AxiosService from "../axios-service/AxiosService";
import { AxiosError, AxiosResponse } from "axios";
import TargetModel from "../models/Targets";
import { PublishRevision } from "../models/PublishRevision";
import { IMiniAppRevisionDeeplink, MiniApp } from "../models/MiniApp";
import { Environment } from "../models/Environment";
import ManagerApiFeatureFlag from "../../utils/ManagerApiFeatureFlag";
const HOST_URL = process.env.REACT_APP_BACKEND_HOST;
export default class MiniAppService {
    static updateMiniApp = async (miniApp: EditMiniApp) => {
        let token = null;
        token = Storage.get(Storage.KEYS.USERTOKEN);

        const config = {
            headers: {
                Authorization: "Bearer " + token,
                ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
            }
        };
        if (!miniApp.parentSlug) miniApp.parentSlug = "";
        if (!miniApp.permissions) miniApp.permissions = [];
        if (!miniApp.icon) delete miniApp.icon;
        delete miniApp.revisions;

        return await AxiosService.httpPut(
            managerBff + "/v1/mini-apps",
            { ...miniApp, id: miniApp.id.toString() },
            config
        );
    };

    static editMiniAppCredentials = async (
        credentials: Credential,
        walletToken: string
    ): Promise<any> => {
        const token = Storage.get(Storage.KEYS.USERTOKEN);
        const config = {
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json"
            }
        };

        if (!credentials.clientSecret) {
            return Promise.reject(
                "Não é possível atualizar a credencial sem o parâmetro clientSecret."
            );
        }
        return await AxiosService.httpPut(
            `${managerBff}/v1/mini-apps/${walletToken}/credential`,
            credentials,
            config
        );
    };

    static editMiniAppSecretKey = async (
        secretKey: string,
        walletToken: string
    ) => {
        const token = Storage.get(Storage.KEYS.USERTOKEN);
        const config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        if (!secretKey) {
            return Promise.reject(
                "Não é possível atualizar o secret key, o parâmetro secretKey está vazio."
            );
        }
        return await AxiosService.httpPut(
            `${managerBff}/v1/mini-apps/${walletToken}/secretKey`,
            { secretKey },
            config
        );
    };

    static updateRevision = async (
        revision: PublishRevision,
        publicKey: string,
        environmentId?: string,
        versionId?: string
    ): Promise<AxiosResponse<MiniApp>> => {
        let token = null;
        const { version } = revision;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }

        const config = {
            headers: {
                Authorization: "Bearer " + token,
                ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
            }
        };

        return await AxiosService.httpPut(
            `${managerBff}/v1/mini-apps/${publicKey}/revisions/${version}/publish?environmentId=${environmentId}&versionId=${versionId}`,
            revision,
            config
        );
    };

    static rejectRevision = async (
        revision: PublishRevision,
        publicKey: string,
        message: string
    ) => {
        const { version } = revision;
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }

        const config = {
            headers: { Authorization: "Bearer " + token }
        };

        return await AxiosService.httpPut(
            `${managerBff}/v1/mini-apps/${publicKey}/revisions/${version}/reject`,
            { message, ...revision },
            config
        );
    };

    static findMiniApps = async () => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: "Bearer " + token,
                ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
            }
        };
        return await AxiosService.httpGet(managerBff + "/v1/mini-apps", config)
            .then(result => {
                return result.status !== 200 ? [] : result.data.miniApps;
            })
            .catch(e => {
                console.log("Nenhum eitri app encontrado", e);
                return [];
            });
    };

    static getTargets = async (): Promise<TargetModel[]> => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: {
                Authorization: "Bearer " + token,
                ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
            }
        };

        return await AxiosService.httpGet(managerBff + "/v2/targets", config)
            .then(result => {
                return result.status !== 200 ? [] : result.data;
            })
            .catch(e => {
                ErrorHandler.handleError(e);
            });
    };

    static findMiniAppBySlug = (slug: string) => {
        const config = MiniAppService.authOptions();
        return AxiosService.httpGet(
            managerBff + `/v1/mini-apps/${slug}`,
            config
        )
            .then(result => {
                return result.status !== 200 ? [] : result.data;
            })
            .catch(e => {
                ErrorHandler.handleError(e);
            });
    };

    static findMiniAppBySlugWithoutToken = (slug: string) => {
        return AxiosService.httpGet(managerBff + `/v1/mini-apps/o/${slug}`)
            .then(result => {
                return result.status !== 200 ? [] : result.data;
            })
            .catch(e => {
                ErrorHandler.handleError(e);
            });
    };

    static findMiniAppByFeatureToggle(featureToggleKey: string) {
        const config = MiniAppService.authOptions();
        return AxiosService.httpGet(
            managerBff + `/v1/mini-apps?ft=${featureToggleKey}`,
            config
        )
            .then(result => {
                return result.status !== 200 ? [] : result.data;
            })
            .catch(e => {
                ErrorHandler.handleError(e);
            });
    }

    static getLatestRevision = (miniApp: EditMiniApp) => {
        const appTypes = Data.getAppTypes();
        if (miniApp.type === appTypes.EITRI_TYPE_ENGINE && miniApp.revisions) {
            const latestRevision = miniApp.revisions.find(
                revision => revision.latest
            );
            if (latestRevision) {
                return latestRevision;
            }
        }
        return { version: "-", createdAt: "-" };
    };

    static createMiniApp = async (miniApp: CreateMiniApp) => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: { Authorization: "Bearer " + token }
        };

        return await AxiosService.httpPost(
            managerBff + "/v1/mini-apps",
            miniApp,
            config
        );
    };

    static inviteDeveloper = async (slug: string, email: string) => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: { Authorization: "Bearer " + token }
        };
        const response = await AxiosService.httpPut(
            managerBff + `/v1/mini-apps/${slug}/invites/${email}`,
            null,
            config
        );

        return response;
    };

    static disassociateDevelopersFromMiniApp = async (
        emails: Array<string>,
        miniAppId: number
    ) => {
        let token = null;

        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: { Authorization: "Bearer " + token }
        };

        const bodyRequest = {
            emails: emails,
            miniAppId: miniAppId
        };

        const resp = await AxiosService.httpPut(
            `${managerBff}/v1/mini-apps/developer`,
            bodyRequest,
            config
        );
        return resp;
    };

    static getInvites = (slug: string) => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }

        const config = {
            headers: { Authorization: "Bearer " + token }
        };
        return AxiosService.httpGet(
            managerBff + `/v1/mini-apps/${slug}/invites`,
            config
        )
            .then(result => {
                return result.status !== 200 ? [] : result.data;
            })
            .catch(e => {
                ErrorHandler.handleError(e);
            });
    };

    static findDevelopers = () => {
        return AxiosService.httpGet(
            "https://5f4909f68e271c001650c55e.mockapi.io/mockapi/developers/allDevelopers"
        )
            .then(res => {
                return res.data.developers;
            })
            .catch(error => {
                ErrorHandler.handleError(error);
            });
    };

    static findCustomer = async (publicKey: string) => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
            const config = {
                headers: { Authorization: "Bearer " + token }
            };

            const resp = await AxiosService.httpGet(
                `${managerBff}/v1/mini-apps/${publicKey}/customer`,
                config
            );
            const customer: Customer = resp.data;
            return { customer };
        } catch (e) {
            const err = e as AxiosError;
            console.log(err.message);
            return {
                error: err
            };
        }
    };

    static getNumberOfPeopleinRevisions = async (ruleId: string) => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: { Authorization: "Bearer " + token },
            params: { ruleId }
        };

        return await AxiosService.httpGet(
            managerBff + "/v1/featureToggleCustomers/report",
            config
        );
    };

    static compareMiniapps(miniAppFromAPI: any, miniAppFromUser: any) {
        let changes: any = {};
        let hasChanges: boolean = false;
        const apiMiniAppTagHandled = { ...miniAppFromAPI };
        apiMiniAppTagHandled.tags = (miniAppFromAPI.tags || [])
            .map((tag: any) => tag.name)
            .filter((tag: string) => tag !== "default")
            .sort();
        const userMiniAppTagHandled = { ...miniAppFromUser };
        if (miniAppFromUser.tags) {
            userMiniAppTagHandled.tags = miniAppFromUser.tags.slice().sort();
        }
        for (const prop in userMiniAppTagHandled) {
            const userData = userMiniAppTagHandled[prop];
            if (
                MiniAppService.isToUpdate(userData, apiMiniAppTagHandled, prop)
            ) {
                changes[prop] = userData;
                hasChanges = true;
            }
        }
        return {
            changes,
            current: miniAppFromAPI,
            handled: apiMiniAppTagHandled,
            hasChanges
        };
    }

    static isToUpdate(userData: any, miniApp_fromAPI: any, prop: any) {
        if (!userData && userData !== false) {
            return false;
        }

        const userDataAsString: any = JSON.stringify(userData);
        const apiDataAsString: any = JSON.stringify(miniApp_fromAPI[prop]);

        if (userDataAsString !== apiDataAsString) {
            return true;
        }

        return false;
    }

    static approveRevisionVersion = async (
        walletToken: string,
        version: string
    ) => {
        const config = MiniAppService.authOptions();
        const path: string = `/v1/mini-apps/${walletToken}/revisions/${version}/review/approve`;
        const url = `${managerBff}${path}`;
        return await AxiosService.httpPut(url, {}, config);
    };

    static disapproveRevisionVersion = async (
        walletToken: string,
        version: string
    ) => {
        const config = MiniAppService.authOptions();
        const path: string = `/v1/mini-apps/${walletToken}/revisions/${version}/review/disapprove`;
        const url = `${managerBff}${path}`;
        return await AxiosService.httpPut(url, undefined, config);
    };

    static sourcesDownload = async (slug: string, version: string) => {
        const options = MiniAppService.authOptions();
        const path: string = `/v1/mini-apps/${slug}/revisions/${version}/sources`;
        const url = `${managerBff}${path}`;
        return await AxiosService.httpGet(url, options);
    };

    static getRevisionDeeplink = async (payload: IMiniAppRevisionDeeplink) => {
        const options = MiniAppService.authOptions();

        if (options?.headers?.["X-New-Manager-Api"]) {
            delete options?.headers?.["X-New-Manager-Api"];
        }

        const path: string = `/share-api/share`;
        const url = `${HOST_URL}${path}`;
        return await AxiosService.httpPost(url, payload, options);
    };

    static getEnvironmentByTargetName = async (
        targetName: string,
        applicationId?: string
    ): Promise<AxiosResponse<Environment[]>> => {
        const options = MiniAppService.authOptions();
        const path: string = `v1/environments/target/${targetName}?applicationId=${applicationId}`;
        const url = `${managerBff}/${path}`;
        return await AxiosService.httpGet(url, options);
    };

    static authOptions = () => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }

        const config = {
            headers: {
                Authorization: "Bearer " + token,
                ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
            }
        };
        return config;
    };
}
